import React, { Fragment, useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { Modal, Dropdown } from 'react-bootstrap'

import { SET_ACCOUNT } from 'store/account/action'
import { httpOk, GUESTGET, GUESTPOST, GUESTPUT } from 'helpers/api'
import { clearTemporaryStorage, formatMoney, formatMoneyInput } from 'helpers/helpers'

import logo from "assets/images/logo_white.png";

function Login() {
	const { i18n, t } = useTranslation()
	const navigate = useNavigate()
	const dispatch = useDispatch()

	const [user, setUser] = useState({ "login": "", "password": "" })
	const [modalPayment, setModalPayment] = useState({ "bool": false, "data": {}, activeTab: 1 })
	const [modalApps, setModalApps] = useState(false)
	const [versions, setVersions] = useState({})
	const [copiedIndex, setCopiedIndex] = useState(null);

	async function handleSubmit(e = null) {
		if (e) e.preventDefault();

		var sendData = {
			login: user.login.toLowerCase(),
			password: user.password
		}
		clearTemporaryStorage()
		var response = await GUESTPOST('/login', sendData, { loader: true })

		if (!httpOk(response)) {
			if (response.data.code === -1) {
				response.data.amount = response?.data.tariff
				setModalPayment({ ...modalPayment, 'bool': true, 'data': response?.data })
			}
		}

		if (response?.status >= 200) {
			response = response.data

			dispatch(SET_ACCOUNT(response))
			localStorage.setItem("login", user.login.toLowerCase());
			localStorage.setItem("role", response.role);
			localStorage.setItem('token', response.token)

			switch (response.role) {
				case 'ROLE_ADMIN':
					navigate("/admin/users")
					break;
				case 'ROLE_OWNER':
					navigate("/dashboard-main")
					break;
				case 'ROLE_DIRECTOR':
					navigate("/dashboard-main")
					break;
				case 'ROLE_CASHIER':
					navigate("/dashboard-main")
					break;
				case 'ROLE_CALL_CENTER':
					navigate("/delivery/orders")
					break;
				case 'ROLE_PARTNER':
					navigate("/partner/dashboard")
					break;
				default:
					//toast.error(t('you_do_not_have_access'))
					break;
			}
		}
	}

	async function createInvoice() {
		var sendData = {
			login: user.login.toLowerCase(),
			id: modalPayment.data.pos_id,
			amount: modalPayment.data.amount,
			phone: `998${modalPayment.data.phone}`,
			pos_payment_type_id: 1,
		}

		var response = await GUESTPOST('/payment/pos-invoice', sendData, { loader: true })

		if (!httpOk(response)) {
			if (response.data.code === -1) {
				setModalPayment({ ...modalPayment, 'bool': true, 'data': response?.data })
			}
		}
	}

	async function activateCredit() {
		var sendData = {
			'login': modalPayment.data.login,
			'pos_id': modalPayment.data.pos_id
		}

		var response = await GUESTPUT('/pos/activate-credit', sendData, { loader: true })
		if (httpOk(response)) handleSubmit()
	}

	function handleChange(e) {
		if (Number(e.target.value.replace(/[^0-9.]/g, '') && e.target.name === 'amount') > 50000000) return

		var modalPaymentCopy = { ...modalPayment }
		modalPayment.data[e.target.name] = e.target.value.replace(/[^0-9.]/g, '')

		setModalPayment(modalPaymentCopy)
	}

	function toggleModalPayment(bool) {
		setModalPayment({ ...modalPayment, 'bool': bool })
	}

	async function toggleModalApps(bool) {
		if (bool) {
			var response = await GUESTGET('/application-versions', {}, { loader: true })
			if (httpOk(response)) setVersions(response.data)
		}

		setModalApps(bool)
	}

	function handleCopy(text, index) {
		navigator.clipboard.writeText(text) // Копируем текст в буфер обмена
			.then(() => {
				setCopiedIndex(index); // Устанавливаем индекс кнопки
				setTimeout(() => setCopiedIndex(null), 1000); // Убираем уведомление через 2 секунды
			})
			.catch((error) => {
				console.error("Ошибка копирования: ", error);
			});
	};

	function findKeyFromArrayByValue(array, valueName, value, key) {
		if ((array.length > 0 && value) || value === 0) {
			var found = array.find(x => x[valueName] === value)
			return found ? found[key] : '';
		}
	}

	function changeLanguage(language = 'uz_latn') {
		i18n.changeLanguage(language);

		if (language === 'ru') {
			localStorage.setItem('lang', 'ru');
		}
		if (language === 'uz_latn') {
			localStorage.setItem('lang', 'uz_latn');
		}
		if (language === 'uz_cyrl') {
			localStorage.setItem('lang', 'uz_cyrl');
		}
		if (language === 'tr') {
			localStorage.setItem('lang', 'tr');
		}
	};

	function getCurrentLocale() {
		const locale = i18n.language
		if (locale === 'ru') return { lang: 'russian' }
		else if (locale === 'uz_latn') return { lang: 'uzbek_latn' }
		else if (locale === 'uz_cyrl') return { lang: 'uzbek_cyrl' }
		else if (locale === 'tr') return { lang: 'turkish' }
	}

	const LanguageToggle = React.forwardRef(({ children, onClick }, ref) => (
		<span ref={ref} onClick={(e) => { e.preventDefault(); onClick(e); }}>
			{children}
		</span>
	));

	return (
		<>
			<div className="authentication-bg">
				<div className="auth-card">
					<div className="d-flex justify-content-center">
						<div className="form-wrapper">
							<div className="login-logo">
								<img src={logo} alt="" width={250} />
							</div>

							<form className="login-form"
								autoComplete="off"
								onSubmit={(e) => handleSubmit(e)}>
								<div style={{ 'fontSize': '35px', 'color': '#fff', 'textAlign': 'center' }}>
									{t('logging_in')}
								</div>

								<div className="form-group w-100">
									<label style={{ color: '#fff' }}>{t('login')}</label>
									<input className="form-control"
										name="login"
										autoFocus
										value={user.login}
										onChange={(e) => setUser({ ...user, 'login': e.target.value.toLowerCase() })} />
								</div>

								<div className="form-group w-100">
									<label style={{ color: '#fff' }}>{t('password')}</label>
									<input className="form-control"
										name="password"
										type="password"
										value={user.password}
										onChange={(e) => setUser({ ...user, 'password': e.target.value })} />
								</div>

								<div className="w-100 text-center">
									<button type="submit" className="btn btn-dark w-100">
										{t('enter')}
									</button>
								</div>

								<div className="text-center mt-2">
									<Link to="/auth/forgot-password" className="fw-medium text-white">{t('forgot_password')}</Link>
								</div>
								<div className="text-center cursor" onClick={() => toggleModalApps(true)}>
									<b className="fw-medium text-white">{t('applications')}</b>
								</div>
							</form>
						</div>
					</div>
				</div>

				<div className="position-absolute lang-position">
					<Dropdown className="cursor-pointer d-flex cursor">
						<Dropdown.Toggle as={LanguageToggle}>
							<div className="d-flex gap-2">
								<i className="uil uil-globe"></i>
								<span>{t(getCurrentLocale().lang)}</span>
							</div>
						</Dropdown.Toggle>

						<Dropdown.Menu>
							{i18n.language !== 'ru' &&
								<Dropdown.Item onClick={() => changeLanguage("ru")}>
									<span>{t('russian')}</span>
								</Dropdown.Item>
							}
							{i18n.language !== 'uz_latn' &&
								<Dropdown.Item onClick={() => changeLanguage("uz_latn")}>
									<span>{t('uzbek_latn')}</span>
								</Dropdown.Item>
							}
							{i18n.language !== 'uz_cyrl' &&
								<Dropdown.Item onClick={() => changeLanguage("uz_cyrl")}>
									<span>{t('uzbek_cyrl')}</span>
								</Dropdown.Item>
							}
							{i18n.language !== 'tr' &&
								<Dropdown.Item onClick={() => changeLanguage("tr")}>
									<span>{t('turkish')}</span>
								</Dropdown.Item>
							}
						</Dropdown.Menu>
					</Dropdown>
				</div>
			</div>

			{/* MODAL */}
			<Modal show={modalPayment.bool} animation={false} size="lg"
				dialogClassName="update-modal-width" centered backdrop="static"
				onHide={() => toggleModalPayment(false)}>
				<Modal.Header closeButton>
					<h3>Оплата</h3>
				</Modal.Header>
				<Modal.Body>

					<div className="d-flex justify-content-between gap-3">
						<div className="d-flex flex-column gap-2 fz-18">
							<div className={`tab ${modalPayment.activeTab === 1 ? 'active' : ''}`}
								onClick={() => setModalPayment({ ...modalPayment, activeTab: 1 })}>
								Выставить счет
							</div>
							<div className={`tab ${modalPayment.activeTab === 3 ? 'active' : ''}`}
								onClick={() => setModalPayment({ ...modalPayment, activeTab: 3 })}>
								Доверительный платеж
							</div>
						</div>

						<div className="w-100" style={{ 'height': '300px' }}>
							<div className="h-100 vertical-between">
								<div>
									<div className="d-flex justify-content-between">
										<div>{t('pos')}</div>
										<div>{modalPayment.data.pos_name}</div>
									</div>

									<div className="d-flex justify-content-between">
										<div>{t('id')}</div>
										<div>{modalPayment.data.pos_id}</div>
									</div>

									<div className="d-flex justify-content-between">
										<div>{t('tariff')}</div>
										<div>{formatMoney(modalPayment.data.tariff)}</div>
									</div>

									<div className="d-flex justify-content-between">
										<div>{t('balance2')}</div>
										<div>{formatMoney(modalPayment.data.balance)}</div>
									</div>

									<hr />
								</div>
								{modalPayment.activeTab === 1 &&
									<div className="d-flex flex-column gap-2">
										<input type="text" className="form-control"
											autoComplete="off"
											name="amount"
											placeholder={t('amount')}
											value={formatMoneyInput(modalPayment.data.amount)}
											onChange={(e) => handleChange(e)}
										/>

										<div className="input-group">
											<span className="input-group-text">998</span>
											<input type="text" className="form-control"
												autoComplete="off"
												name="phone"
												value={(modalPayment.data.phone)}
												onChange={(e) => handleChange(e)} />
										</div>

										<button type="button" className="btn btn-primary w-100"
											onClick={() => createInvoice()}>
											{t('pay')}
										</button>
									</div>
								}

								{modalPayment.activeTab === 3 &&
									<div>
										<div>
											<p className="fz-16">
												*После активации “доверительный платеж”
												не забудьте оплатить абоненскую плату, во избежания блокировки входа в систему.
											</p>
											{(modalPayment.data.code === -1 && modalPayment.data.show_credit_button) &&
												<div className="d-flex mt-2">
													<div className="form-check">
														<input type="checkbox" className="form-check-input"
															onClick={(e) => setModalPayment({ ...modalPayment, 'agree': e.target.checked })}
															checked={modalPayment.agree} />
													</div>
													<span className="text-primary fz-16 fw-500">Я согласен</span>
												</div>
											}
										</div>
										{(modalPayment.data.code === -1 && !modalPayment.data.show_credit_button) &&
											<p className="text-center text-danger">Эту функцию можно активировать с 1 по 3 числа каждого календарного месяца</p>
										}
										{(modalPayment.data.code === -1 && modalPayment.data.show_credit_button) &&
											<Fragment>
												<div className="text-center mt-2">
													<button type="button" className="btn btn-primary w-75"
														disabled={(modalPayment.credit_date || !modalPayment.agree)}
														onClick={activateCredit}>
														Активировать
													</button>
												</div>
												<p className="text-center">Активировать доверительный <br />платеж на 1 день</p>
											</Fragment>
										}
									</div>
								}
							</div>
						</div>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL */}

			{/* MODAL */}
			<Modal show={modalApps} animation={false}
				centered backdrop="static"
				onHide={() => toggleModalApps(false)}>
				<Modal.Header closeButton>
					<h4>{t('applications')}</h4>
				</Modal.Header>
				<Modal.Body>
					<div>
						<div className="d-flex justify-content-between mb-2">
							<h6 className="vertical-center">
								<b>1. KingPlov Kassa{findKeyFromArrayByValue(versions, 'type', 'desktop_client', 'version')}(.exe)</b>
							</h6>
							<a className="btn btn-sm btn-primary"
								href={`https://download.kingplovv.uz/desktop_client/KingPlov${findKeyFromArrayByValue(versions, 'type', 'desktop_client', 'version')}(x64).exe`}
								style={{ 'width': '100px' }}
								onClick={() => { }}>
								{t('download')}
							</a>
						</div>
						<div className="d-flex justify-content-between mb-2">
							<h6 className="vertical-center">
								<b>2. KingPlov Owner {findKeyFromArrayByValue(versions, 'type', 'android_owner', 'version')}</b>
							</h6>
							<div style={{ position: 'relative', display: 'inline-block' }}>
								<button className="btn btn-sm btn-primary"
									style={{ 'width': '100px' }}
									onClick={() => handleCopy('https://onelink.to/fvdfrx', 1)}>
									{t('copy')}
								</button>
								{copiedIndex === 1 && (
									<div style={{
										position: 'absolute',
										top: '-30px',
										left: '50%',
										transform: 'translateX(-50%)',
										background: 'black',
										color: 'white',
										padding: '5px 10px',
										borderRadius: '5px',
										fontSize: '12px',
										zIndex: 1000,
										opacity: 0.9,
									}}>
										{t('copied')}
									</div>
								)}
							</div>
						</div>
						<div className="d-flex justify-content-between mb-2">
							<h6 className="vertical-center">
								<b>3. KingPlov Waiter {findKeyFromArrayByValue(versions, 'type', 'waiter_android', 'version')}</b>
							</h6>
							<div style={{ position: 'relative', display: 'inline-block' }}>
								<button className="btn btn-sm btn-primary"
									style={{ 'width': '100px' }}
									onClick={() => handleCopy('https://onelink.to/bahapm', 2)}>
									{t('copy')}
								</button>
								{copiedIndex === 2 && (
									<div style={{
										position: 'absolute',
										top: '-30px',
										left: '50%',
										transform: 'translateX(-50%)',
										background: 'black',
										color: 'white',
										padding: '5px 10px',
										borderRadius: '5px',
										fontSize: '12px',
										zIndex: 1000,
										opacity: 0.9,
									}}>
										{t('copied')}
									</div>
								)}
							</div>
						</div>
						<div className="d-flex justify-content-between mb-2">
							<h6 className="vertical-center">
								<b>4. KingPlov Delivery {findKeyFromArrayByValue(versions, 'type', 'android_delivery', 'version')}</b>
							</h6>
							<div style={{ position: 'relative', display: 'inline-block' }}>
								<button className="btn btn-sm btn-primary"
									style={{ 'width': '100px' }}
									onClick={() => handleCopy('https://onelink.to/8t2dtt', 3)}>
									{t('copy')}
								</button>
								{copiedIndex === 3 && (
									<div style={{
										position: 'absolute',
										top: '-30px',
										left: '50%',
										transform: 'translateX(-50%)',
										background: 'black',
										color: 'white',
										padding: '5px 10px',
										borderRadius: '5px',
										fontSize: '12px',
										zIndex: 1000,
										opacity: 0.9,
									}}>
										{t('copied')}
									</div>
								)}
							</div>
						</div>
						<div className="d-flex justify-content-between mb-2">
							<h6 className="vertical-center">
								<b>5. Postgresql(.exe)</b>
							</h6>
							<a className="btn btn-sm btn-primary"
								href="https://download.kingplovv.uz/files/postgresql_12.exe"
								style={{ 'width': '100px' }}
								onClick={() => { }}>
								{t('download')}
							</a>
						</div>
						<div className="d-flex justify-content-between mb-2">
							<h6 className="vertical-center">
								<b>6. AnyDesk(.exe)</b>
							</h6>
							<a className="btn btn-sm btn-primary"
								href="https://download.kingplovv.uz/files/anydesk.exe"
								style={{ 'width': '100px' }}
								onClick={() => { }}>
								{t('download')}
							</a>
						</div>
						<div className="d-flex justify-content-between mb-2">
							<h6 className="vertical-center">
								<b>7. AmmyAdmin3.10(.exe)</b>
							</h6>
							<a className="btn btn-sm btn-primary"
								href="https://download.kingplovv.uz/files/ammyadmin.exe"
								style={{ 'width': '100px' }}
								onClick={() => { }}>
								{t('download')}
							</a>
						</div>
						<div className="d-flex justify-content-between mb-2">
							<h6 className="vertical-center">
								<b>8. Teamviewer(.exe)</b>
							</h6>
							<a className="btn btn-sm btn-primary"
								href="https://download.kingplovv.uz/files/Teamviewer.exe"
								style={{ 'width': '100px' }}
								onClick={() => { }}>
								{t('download')}
							</a>
						</div>
						<div className="d-flex justify-content-between mb-2">
							<h6 className="vertical-center">
								<b>9. XPrinter Driver Setup V7.77(.exe)</b>
							</h6>
							<a className="btn btn-sm btn-primary"
								href="https://download.kingplovv.uz/files/XPrinterV7.77.exe"
								style={{ 'width': '100px' }}
								onClick={() => { }}>
								{t('download')}
							</a>
						</div>
						<div className="d-flex justify-content-between mb-2">
							<h6 className="vertical-center">
								<b>10. XPrinter_80(.exe)</b>
							</h6>
							<a className="btn btn-sm btn-primary"
								href="https://download.kingplovv.uz/files/xprinter_80.exe"
								style={{ 'width': '100px' }}
								onClick={() => { }}>
								{t('download')}
							</a>
						</div>
						<div className="d-flex justify-content-between mb-2">
							<h6 className="vertical-center">
								<b>11. XPrinterV3.0C(.exe)</b>
							</h6>
							<a className="btn btn-sm btn-primary"
								href="https://download.kingplovv.uz/files/XPrinterV3.0C.rar"
								style={{ 'width': '100px' }}
								onClick={() => { }}>
								{t('download')}
							</a>
						</div>
						<div className="d-flex justify-content-between mb-2">
							<h6 className="vertical-center">
								<b>12. FiscalDriveAPI(.zip)</b>
							</h6>
							<a className="btn btn-sm btn-primary"
								href="https://download.kingplovv.uz/files/FiscalDriveAPI.zip"
								style={{ 'width': '100px' }}
								onClick={() => { }}>
								{t('download')}
							</a>
						</div>
						<div className="d-flex justify-content-between mb-2">
							<h6 className="vertical-center">
								<b>13. BioAccess(.exe)</b>
							</h6>
							<a className="btn btn-sm btn-primary"
								href="https://download.kingplovv.uz/files/BioAccess.exe"
								style={{ 'width': '100px' }}
								onClick={() => { }}>
								{t('download')}
							</a>
						</div>
						<div className="d-flex justify-content-between mb-2">
							<h6 className="vertical-center">
								<b>14. BioAccessDriver(.exe)</b>
							</h6>
							<a className="btn btn-sm btn-primary"
								href="https://download.kingplovv.uz/files/BioAccessDriver.exe"
								style={{ 'width': '100px' }}
								onClick={() => { }}>
								{t('download')}
							</a>
						</div>
					</div>
				</Modal.Body>
			</Modal>
			{/* MODAL */}
		</>
	)
}

export default Login;
